<template>
  <div class="header">
    <!-- <a
      href="#Accesskey_C"
      id="gotocenter"
      title="移至主要內容"
      class="Go-content"
      >跳到主要內容</a
    > -->

    <b-container fluid class="TopNavGroup">
      <h1 class="mainLogo">
        <b-link to="/" title="返回 2026臺灣文化遺產國際論壇 首頁">2026臺灣文化遺產國際論壇</b-link>
      </h1>

      <div class="mainNav">
        <div class="nav-itemsGroup">
              <div class="nav-item">
                <b-link
                  to="/"
                  title="返回 2026臺灣文化遺產國際論壇 首頁"
                  >{{ $t("TopNav01") }}</b-link
                >
              </div>
              <div class="nav-item">
                <b-link
                  to="About"
                  title="前往 關於論壇"
                  >{{ $t("TopNav02") }}</b-link
                >
              </div>
              <!-- <div class="nav-item">
                <b-link
                  to="Guest"
                  title="前往 與會貴賓"
                  >{{ $t("TopNav03") }}</b-link
                >
              </div> -->
              <div class="nav-item">
                <b-link
                  to="Agenda"
                  title="前往 議程與講者"
                  >{{ $t("TopNav04") }}</b-link
                >
              </div>
              <div class="nav-item">
                <b-link
                  to="Venue"
                  title="前往 場地資訊"
                  >{{ $t("TopNav06") }}</b-link
                >
              </div>
              <div class="nav-item">
                <b-link
                  to="Contact"
                  title="前往 聯絡資訊"
                  >{{ $t("TopNav07") }}</b-link
                >
              </div>
              <div class="nav-item">
                <a
                  href="https://www.surveycake.com/s/DrWBR"
                  target="_blank"
                  title="前往 論壇報名"
                  >{{ $t("TopNav05") }}</a
                >
              </div>
              <div class="nav-item lang-item"><span class="lang-label">語言 / Language</span><b-form-select
                  @change="setLang"
                  v-model="langSelected"
                  :options="langOptions"
                ></b-form-select>
              </div>
        </div>
      </div>
      <b-link
        class="btn1"
        @click="navBarActive = !navBarActive"
        value="顯示導覽列"
        title="顯示導覽列"
        alt="顯示導覽列"
        ><i
          class="fa"
          :class="{ 'fa-bars': !navBarActive, 'fa-times': navBarActive }"
          aria-hidden="true"
        ></i
        ><span class="sr-only">導覽列</span></b-link
      >
      <nav class="TopNav">
        <div class="nav-items" :class="{ navSlider: navBarActive }">
          <b-container fluid>
            <ul class="nav-itemsTOP">
              <li>
                <b-link
                  to="/"
                  @click="navBarActive = !navBarActive"
                  title="返回 2026臺灣文化遺產國際論壇 首頁"
                  >{{ $t("TopNav01") }}</b-link
                >
              </li>
              <li>
                <b-link
                  to="About"
                  @click="navBarActive = !navBarActive"
                  title="前往 關於論壇"
                  >{{ $t("TopNav02") }}</b-link
                >
              </li>
              <!-- <li>
                <b-link
                  to="Guest"
                  @click="navBarActive = !navBarActive"
                  title="前往 與會貴賓"
                  >{{ $t("TopNav03") }}</b-link
                >
              </li> -->
              <li>
                <b-link
                  to="Agenda"
                  @click="navBarActive = !navBarActive"
                  title="前往 精彩議程"
                  >{{ $t("TopNav04") }}</b-link
                >
              </li>
              <li>
                <b-link
                  to="Venue"
                  @click="navBarActive = !navBarActive"
                  title="前往 場地資訊"
                  >{{ $t("TopNav06") }}</b-link
                >
              </li>
              <li>
                <b-link
                  to="Contact"
                  @click="navBarActive = !navBarActive"
                  title="前往 聯絡資訊"
                  >{{ $t("TopNav07") }}</b-link
                >
              </li>
              <li>
                <a
                  href="https://www.surveycake.com/s/DrWBR"
                  title="前往 論壇報名"
                  target="_blank"                  
                  >{{ $t("TopNav05") }}</a
                >
              </li>
              <li>
                <span class="lang-label">語言 / Language</span>
                <b-form-select
                  @change="setLang"
                  v-model="langSelected"
                  :options="langOptions"
                ></b-form-select>
              </li>
            </ul>
          </b-container>
        </div>
      </nav>


      
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navBarActive: false,
        langSelected: "ZH",
        langOptions: [
          {
            value: "EN",
            text: "English",
          },
          {
            value: "ZH",
            text: "繁體中文",
          },
        ],
      };
    },
    mounted() {
      if (sessionStorage.getItem("language") != null) {
        this.langSelected = sessionStorage.getItem("language");
      }
    },
    watch: {},
    methods: {
      // 儲存切換的語系
      setLang() {
        sessionStorage.setItem("language", this.langSelected);
        location.reload();
      },

      goToSignUp() {
        alert("本論壇暫停線上報名管道，自9/1起報名者，將視為現場報名，欲參加論壇者，歡迎直接現場報名參加。\n造成不便，敬請見諒。")
        window.open("https://forms.gle/am2QVZTjfZRq7pBF8", "_blank")
      }
    },
  };
</script>

<style lang="scss">

</style>
